<template>
  <header v-if="title" class="order-summary__header order-recap-title">
    <span class="order-summary__header-icon" aria-hidden="true">
      <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        />
      </svg>
    </span>
    <span class="order-summary__header-label">{{ title }}</span>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: "OrderRecapTitle",
  computed: {
    title() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;

      if (retryOrderId) {
        return this.$t("messages.orderSummaryRetry");
      } else {
        return this.$t("messages.orderSummaryDefault");
      }
    },
  },
  methods: {},
};
</script>
